// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__5ZRcF","content":"GlobalSearch_content__3fjty"};